import React from 'react'

export function TableBody({ component, children }) {
  return React.createElement(component, { children })
}
